import { type PropsWithChildren, Suspense, useEffect } from "react"

import { env } from "../../env"
import { useProfile } from "../../services/user"

export function Intercom(props: PropsWithChildren) {
  return (
    <>
      <Suspense>
        <BlockingIntercom />
      </Suspense>
      {props.children}
    </>
  )
}

function BlockingIntercom() {
  useInstallIntercom()

  return null
}

interface IntercomSettings {
  app_id: string
  user_id: string
  email: string
  user_hash: string
  name: string
}

interface Intercom {
  (action: "boot", settings: IntercomSettings): void
  (action: "shutdown"): void
}

declare global {
  interface Window {
    Intercom: Intercom
  }
}

// Note: This is placed inside its own Suspense boundary so that we don't block the rest of the app from rendering immediately.
function useInstallIntercom() {
  const { shortId, email, firstName, lastName, intercomHash } = useProfile()

  const name = `${firstName} ${lastName}`

  useEffect(() => {
    if (env.PRISMIC_DEMO) return

    const settings = {
      app_id: env.PRISMIC_INTERCOM_APP_ID,
      user_id: shortId,
      email,
      user_hash: intercomHash,
      name,
    }

    window.Intercom("boot", settings)
  }, [email, intercomHash, name, shortId])
}

export function shutdownIntercom() {
  if (env.PRISMIC_DEMO) return

  window.Intercom("shutdown")
}
